/* Dependencies
 ----------------------------------------------------------*/
import {Application} from "wrapper6";

/* Vendor
 ----------------------------------------------------------*/


/* Setup
 ----------------------------------------------------------*/
var app = window.app = new Application(window.options || {});

/* Services
 ----------------------------------------------------------*/


/* Register services
 ----------------------------------------------------------*/

/* Modules
 ----------------------------------------------------------*/
import Navigation from "modules/_navigation";
import ObjectFit from "modules/_object-fit";
import Print from "modules/_print";
import ContactForm from "modules/_contact-form";

/* Register modules
 ----------------------------------------------------------*/
app.use(Navigation);
app.use(ObjectFit);
app.use(Print);
app.use(ContactForm);

require('./app');